import React, {Component} from 'react';
import logo from './logo.svg';
import './logo.css';

export default class Logo extends Component {
    render() {
        return (
            <a href="https://aitom.cz" className="Logo">
                <img src={logo} className="Logo" alt="logo"/>
            </a>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/logo/index.js